/** CRM stakeholder type strings (parity with buxusweb `constants.js`). */
export const STAKEHOLDER_TIER_II = "ET - Tier II";
export const STAKEHOLDER_COMMANDER = "EC - Commander";
export const STAKEHOLDER_EMERGENCY_RESPONDER = "ER - Emergency Responder";
export const STAKEHOLDER_EXCAVATOR = "EX - Excavator";
export const STAKEHOLDER_FARMER = "FM - Farmer";
export const STAKEHOLDER_PUBLIC_OFFICIAL = "PO - Public Official";
export const STAKEHOLDER_AFFECTED_PUBLIC = "AP - Affected Public";
export const STAKEHOLDER_SCHOOL_REP = "SC - School Rep";
export const STAKEHOLDER_OTHER = "OT - Other";

export type StakeholderType =
  | typeof STAKEHOLDER_TIER_II
  | typeof STAKEHOLDER_COMMANDER
  | typeof STAKEHOLDER_EMERGENCY_RESPONDER
  | typeof STAKEHOLDER_EXCAVATOR
  | typeof STAKEHOLDER_FARMER
  | typeof STAKEHOLDER_PUBLIC_OFFICIAL
  | typeof STAKEHOLDER_AFFECTED_PUBLIC
  | typeof STAKEHOLDER_SCHOOL_REP
  | typeof STAKEHOLDER_OTHER;

export const ALL_STAKEHOLDER_TYPES: readonly StakeholderType[] = [
  STAKEHOLDER_AFFECTED_PUBLIC,
  STAKEHOLDER_COMMANDER,
  STAKEHOLDER_EMERGENCY_RESPONDER,
  STAKEHOLDER_EXCAVATOR,
  STAKEHOLDER_FARMER,
  STAKEHOLDER_OTHER,
  STAKEHOLDER_PUBLIC_OFFICIAL,
  STAKEHOLDER_SCHOOL_REP,
  STAKEHOLDER_TIER_II,
];
